/** 인메모리 액세스 토큰 저장소를 만든다. */
export function createAccessTokenStore() {
    let state = null;
    let refreshTimer = null;
    let onRefreshNeeded = null;
    const REFRESH_LEAD_MS = 60_000;
    function getAccessToken() {
        if (!state) {
            return null;
        }
        // 만료 시각이 지났으면 토큰을 쓰지 않는다. 호출 측이 갱신·재인증으로 이어지게 한다.
        if (Date.now() >= state.expiresAtMs) {
            return null;
        }
        return state.token;
    }
    function setAccessToken(token, expiresAtIso, familyId) {
        const expiresAtMs = new Date(expiresAtIso).getTime();
        state = {
            token,
            expiresAtMs,
            familyId: familyId ?? state?.familyId ?? null,
        };
        scheduleProactiveRefresh();
    }
    function getFamilyId() {
        return state?.familyId ?? null;
    }
    function clearAccessToken() {
        state = null;
        if (refreshTimer) {
            clearTimeout(refreshTimer);
            refreshTimer = null;
        }
    }
    function setRefreshHandler(handler) {
        onRefreshNeeded = handler;
    }
    function scheduleProactiveRefresh() {
        if (refreshTimer) {
            clearTimeout(refreshTimer);
            refreshTimer = null;
        }
        if (!state || !onRefreshNeeded) {
            return;
        }
        const delay = state.expiresAtMs - Date.now() - REFRESH_LEAD_MS;
        // 남은 유효 시간이 선행 갱신 여유보다 짧으면 즉시 갱신한다.
        if (delay <= 0) {
            void onRefreshNeeded();
            return;
        }
        refreshTimer = setTimeout(() => {
            void onRefreshNeeded?.();
        }, delay);
    }
    return { getAccessToken, getFamilyId, setAccessToken, clearAccessToken, setRefreshHandler };
}
//# sourceMappingURL=accessTokenStore.js.map